<template>
  <div class="payment">
    <div class="payment_top">
      <van-icon style="position: absolute; left: 10px" size="25" name="arrow-left" @click="to()" />
    </div>
    <!-- {{ status }} -->
    <div class="payment_bottom" v-show="status === 'TRADE_SUCCESS'">
      <img src="../../../assets/mylogin/paySuccess.png" alt="" />
    </div>
    <div class="payment_bottom" v-show="status === 'WAIT_BUYER_PAY'">
      <img src="../../../assets/mylogin/waitPay.png" alt="" />
    </div>
    <div class="payment_bottom" v-show="status === 'TRADE_CLOSED'">
      <img src="../../../assets/mylogin/payError.png" alt="" />
    </div>
    <div class="payment_button">
      <van-button type="info" round class="homepage" @click="homepage">返回首页</van-button>
      <van-button type="default" round class="vieworder" @click="vieworder">查看订单</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "payment",
  data() {
    return {
      status: "",
    };
  },
  created() {
    this.status = this.$route.query.status;
  },
  methods: {
    to() {
      window.history.go(-1);
    },

    // 返回首页
    homepage() {
      this.$router.push("index");
    },
    // 查看订单
    vieworder() {
      // 跳转详情页，携带订单id status用于在详情页 查询主订单 详情
      this.$router.push({ path: "/orders" })
    },
  },
};
</script>

<style lang="scss" scoped>
.payment {
  width: 100vw;
  min-height: 100vh;
  background: #fff;

  .payment_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
  }

  .payment_bottom {
    width: 100%;
    margin-top: 139px;
    text-align: center;

    img {
      width: 83px;
      height: 83px;
    }
  }

  .payment_button {
    width: 75%;
    height: 40px;
    display: flex;
    margin: 85px auto;
    // justify-content: center;
    justify-content: space-between;

    .homepage {
      width: 130px;
      height: 40px;
    }

    .vieworder {
      width: 130px;
      height: 40px;
    }
  }
}
</style>